import { useCallback } from 'react'
import ReactCountryFlag from 'react-country-flag'
import useI18n from '@/shared/hooks/useI18n'
import { useSession } from '@/shared/hooks/useSession'
import { TableCell, TableRow } from '@/common/components/Table/Table'
import { Button, Partnership } from '@/common'
import { useAcceptPartnershipInvitation } from '@/shared/hooks/api/partnerships'
import { CheckCircleIcon, CircleXIcon } from '@/common/components/icons'

export default function IncomingImporterRow({
  partnership,
  onReject
}: {
  partnership: Partnership
  onReject: () => void
}) {
  const { t, dateFormatter } = useI18n()
  const organization = useSession().session.organization
  const { mutateAsync: acceptInvitation, isPending: isAccepting } = useAcceptPartnershipInvitation()

  const onApproveClick = useCallback(async () => {
    await acceptInvitation({
      organizationId: organization.id,
      partnershipId: partnership.id
    })
  }, [acceptInvitation, organization.id, partnership.id])

  return (
    <TableRow key={partnership.id} className="w-full">
      <TableCell>
        <div className="flex items-start gap-2">
          <ReactCountryFlag countryCode={partnership.country} className="relative top-1" svg />
          {partnership.name}
        </div>
      </TableCell>
      <TableCell>{dateFormatter(new Date(partnership.invitationSentAt))}</TableCell>
      <TableCell>
        <div className="flex items-center gap-2">
          <Button
            icon={<CircleXIcon />}
            variant="danger"
            sizeType="sm"
            className="ml-2"
            onClick={onReject}
          >
            {t('importers:importerIncomingList.actions.reject')}
          </Button>
          <Button
            disabled={isAccepting}
            isLoading={isAccepting}
            icon={<CheckCircleIcon />}
            variant="subtle"
            sizeType="sm"
            className="ml-2"
            onClick={onApproveClick}
          >
            {t('importers:importerIncomingList.actions.accept')}
          </Button>
        </div>
      </TableCell>
    </TableRow>
  )
}
